<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人设置</el-breadcrumb-item>
        <el-breadcrumb-item>机器人工作日志表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <el-tabs type="border-card" @tab-click="handleClick">
            <el-tab-pane label="工作日志">
                <!-- 第一行筛选框 -->
                <el-row :gutter="20">
                    <el-col :span="6">
                                <el-date-picker v-model="workWarn.warnTimeStr"  type="date"  value-format="yyyy-MM-dd"  placeholder="日志日期" class="m-l-30 ell-input"> </el-date-picker>
                    </el-col>
                </el-row>
                <!-- 第二行筛选框 -->
                <el-row :gutter="20" >
                        <!-- 创建时间 -->
                    <el-col align="middle" >
                        <el-button type="primary" @click="searchWorkWarn('1')">查询</el-button>
                        <el-button type="primary" @click="exportWorkWarns('1')">导出excl</el-button>
                        <el-button type="info" @click="clearParams()">重置</el-button>
                        <el-button type="primary" @click="returnMissionPlanning()" >返回</el-button>
                    </el-col>   
                </el-row> 
                <!-- 用户列表区域 -->
                <el-table :data="workWarnList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column label="机器编号" prop="robotNo" width="250"></el-table-column>
                    <el-table-column label="机器名称" prop="robotName" width="250"></el-table-column>
                    <el-table-column label="日志类型"  width="100">
                        <template   slot-scope="scope">
                            <span v-if="scope.row.warnType==='2'" style="color:red" >
                                错误日志
                            </span>
                            <span v-if="scope.row.warnType==='1'" >
                                工作日志
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="日志" prop="ip" width="500">
                        <template   slot-scope="scope">
                            <span v-if="scope.row.warnType==='2'"  style="color:red">
                                {{scope.row.warnDetails}}
                            </span>
                            <span v-if="scope.row.warnType==='1'" >
                                {{scope.row.workDetails}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="日志时间" prop="warnTime" width="150"></el-table-column>
                </el-table>
                <!-- 分页区间 -->
                <el-pagination   @current-change="handleCurrentChangeWork"  :current-page.sync="workWarn.wnum"  
                        :page-size="20"  layout="total, prev, pager, next"  :total="total">
                </el-pagination>
            </el-tab-pane>
        <el-tab-pane label="错误日志">
            <!-- 第一行筛选框 -->
                <el-row :gutter="20">
                    <el-col :span="6">
                                <el-date-picker v-model="workWarn.warnTimeStr"  type="date"  value-format="yyyy-MM-dd"  placeholder="日志日期" class="m-l-30 ell-input"> </el-date-picker>
                    </el-col>
                </el-row>
                <!-- 第二行筛选框 -->
                <el-row :gutter="20" >
                        <!-- 创建时间 -->
                    <el-col align="middle" >
                        <el-button type="primary" @click="searchWorkWarn('2')">查询</el-button>
                        <el-button type="primary" @click="exportWorkWarns('2')">导出excl</el-button>
                        <el-button type="info" @click="clearParams()">重置</el-button>
                        <el-button type="primary" @click="returnMissionPlanning()">返回</el-button>
                    </el-col>   
                </el-row> 
                <!-- 用户列表区域 -->
                <el-table :data="workWarnList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column label="机器编号" prop="robotNo" width="250"></el-table-column>
                    <el-table-column label="机器名称" prop="robotName" width="250"></el-table-column>
                    <el-table-column label="日志类型"  width="100">
                        <template   slot-scope="scope">
                            <span v-if="scope.row.warnType==='2'" style="color:red" >
                                错误日志
                            </span>
                            <span v-if="scope.row.warnType==='1'" >
                                工作日志
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="日志" prop="ip" width="500">
                        <template   slot-scope="scope">
                            <span v-if="scope.row.warnType==='2'"  style="color:red">
                                {{scope.row.warnDetails}}
                            </span>
                            <span v-if="scope.row.warnType==='1'" >
                                {{scope.row.workDetails}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="日志时间" prop="warnTime" width="150"></el-table-column>
                </el-table>
                <!-- 分页区间 -->
                <el-pagination   @current-change="handleCurrentChangeErrors"  :current-page.sync="workWarn.enum"  
                        :page-size="20"  layout="total, prev, pager, next"  :total="total">
                </el-pagination>
        </el-tab-pane>
        </el-tabs>
       
    </el-card >
  </div>
</template>

<script>


export default {
  name: 'machine',
  data(){
      return {
          workWarn :{
              robotNo:'',
              robotName:'',
              warnTimeStr:'',
              warnType:'',
              pageNum : 1,
              wnum:1,
              enum:1,
          },
          warnTypes:[
             {
                value: '1',
                label: '工作日志'
            }
            , {
                value: '2',
                label: '错误日志'
            }
          ],
          total:0,
          workWarnList:[],
      }
  },
   //生命周期函数
  created(){
     this.searchWorkWarn(1);
     this.init();
  },
  methods:{
        init(){
            this.$cookies.set("pageFlag", this.$route.query.pageFlag) 
        },
        //点击指定页码跳转
        handleCurrentChangeWork(page){
            this.workWarn.pageNum=page;
            this.searchWorkWarn('1');
        },
        //点击指定页码跳转
        handleCurrentChangeErrors(page){
            this.workWarn.pageNum=page;
            this.searchWorkWarn('2');
        },
        handleClick(tab, event){
            if(tab.index==1){
                this.workWarn.pageNum=1;
                this.searchWorkWarn(2);
            }else{
                this.workWarn.pageNum=1;
                this.searchWorkWarn(1);
            }
        },
        clearParams(){
          this.workWarn.robotNo='';
          this.workWarn.robotName='';
          this.workWarn.warnTimeStr='';
          this.workWarn.warnType='';
        },
         //返回上一页
        returnMissionPlanning(){
            var pageFlag=this.$cookies.get('pageFlag')
            if(pageFlag==="1"){
                this.$router.replace({path: '/missionPlanning'})
            }
            if(pageFlag==="2"){
               this.$router.replace({path: '/robot'})
            }
            if(pageFlag==="3"){
               this.$router.replace({path: '/robotManage'+'?id='+this.$route.query.id})
            }
        },
        //查询日志
        exportWorkWarns(obj){
            var zF = /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）\+={}|《》？：“”【】、；‘'，。、]/
            if(zF.test(this.workWarn.robotNo)||zF.test(this.workWarn.robotName)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.workWarn.warnType=obj;
            if(this.$route.query.robotNo==undefined){
                return this.$message.error("参数异常!");
            }
            this.workWarn.robotNo=this.$route.query.robotNo;
            this.$http({
                method:'get',
                url:'/workWarn/exportWorkWarns',
                params:  this.workWarn,
                responseType:'blob',
                }).then((data) => {
                    if (!data) {
                        return
                    }
                    debugger
                    let url = window.URL.createObjectURL(data.data)
                    let link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = url
                    if(obj==="1"){
                        link.setAttribute('download', '工作日志.xls')
                    }else{
                         link.setAttribute('download', '错误日志.xls')
                    }
                    
                    document.body.appendChild(link)
                    link.click()
                })
            //window.location.href = window.location.origin+'/api/workWarn/exportWorkWarns'
            
        },
        searchWorkWarn(obj){
            var zF = /[`~!@#$%^&*()_\+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）\+={}|《》？：“”【】、；‘'，。、]/
            if(zF.test(this.workWarn.robotNo)||zF.test(this.workWarn.robotName)){
                return this.$message.error("请输入非特殊字符!");
            }
            this.workWarn.warnType=obj;
            if(this.$route.query.robotNo==undefined){
                return this.$message.error("参数异常!");
            }
            this.workWarn.robotNo=this.$route.query.robotNo;
            this.$http.post('/workWarn/selectWorkWarns',JSON.stringify(this.workWarn))
            .then(response => {
                    if (response.data.code === 200) {
                       this.workWarnList=response.data.result.data;
                       this.total=response.data.result.total;
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
        },
      
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}
.map {
        width: 100%;
        height: 400px;
}
.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
 
</style>


// WEBPACK FOOTER //
// src/components/robot/WorkWarn.vue